"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "sc-1bcy1wr-0"
})(["", ""], function (_ref) {
  var rotate = _ref.rotate;
  return "transform: rotate(".concat(rotate, "deg)");
});

var PlusIcon = function PlusIcon(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      rotate = _ref2.rotate;
  return _react["default"].createElement(Svg, {
    rotate: rotate,
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M5.25.75C5.25.33578644 5.58578644 0 6 0s.75.33578644.75.75v10.5c0 .4142136-.33578644.75-.75.75s-.75-.3357864-.75-.75V.75z"
  }), "// eslint-disable-line", _react["default"].createElement("path", {
    d: "M.75 6.75C.33578644 6.75 0 6.41421356 0 6s.33578644-.75.75-.75h10.5c.4142136 0 .75.33578644.75.75s-.3357864.75-.75.75H.75z"
  }), ' ', "// eslint-disable-line"));
};

PlusIcon.propTypes = {
  width: _propTypes.PropTypes.string,
  height: _propTypes.PropTypes.string,
  rotate: _propTypes.PropTypes.number
};
PlusIcon.defaultProps = {
  width: '12px',
  height: '12px',
  rotate: 0
};
var _default = PlusIcon;
exports["default"] = _default;